module.exports = __webpack_public_path__ + "img/blog-8.35f56362.jpg";